import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'sonner'
import App from './App.tsx'
import './globals.css'
import { ToastProvider } from './components/ui/toast-provider'
import { UXEnhancer } from './components/ui/ux-enhancer'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ToastProvider>
        {/* sonner Toaster：承载全站 toast.success/error/info 提示 */}
        <Toaster position="top-center" richColors />
        <UXEnhancer>
          <App />
        </UXEnhancer>
      </ToastProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
